// relative
import type {
  EditMeterUtilityProviderFormValues,
  UtilityProvider,
} from './editMeterUtilityProviderForm.schema';

export function toEditMeterUtilityProviderFormValues(
  currentProvider?: UtilityProvider | null,
): EditMeterUtilityProviderFormValues {
  return { provider: currentProvider ?? null };
}

export function toUtilityProviderId(
  values: EditMeterUtilityProviderFormValues,
): string {
  return values.provider!.provider_id;
}
